import React from "react";
import { motion } from "framer-motion";
import about from "../image/about.png";
import SectionHeading from "./SectionHeading";

function About() {
  return (
    <section id="about" className="bg-gray-50 py-10 sm:py-14 lg:py-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-5 lg:px-8">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-8 text-center md:mb-12"
        >
          <SectionHeading
            badge="WHO WE ARE"
            title="Empowering Businesses with"
            highlight="Smart IT Solutions"
            description="Providing end-to-end technology solutions including web & app development, AI automation, networking, hardware, security systems, and digital marketing to help businesses innovate and grow."
          />
        </motion.div>

        {/* Content */}
        <div className="grid items-center gap-6 md:grid-cols-2 md:gap-8 lg:gap-12">

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="relative order-1 mb-5 w-full md:order-2 md:mb-0"
          >
            <div
              className="
                overflow-hidden
                rounded-2xl
                shadow-[0_20px_45px_rgba(0,0,0,.18)]
                transition-all
                duration-500
                hover:shadow-[0_30px_80px_rgba(220,38,38,.20)]
              "
            >
              <img
                src={about}
                alt="About"
                className="h-[220px] w-full object-cover sm:h-[300px] md:h-[360px] lg:h-[420px]"
              />
            </div>

            {/* Floating Card */}
            <motion.div
              whileHover={{ y: -3 }}
              className="
                absolute
                bottom-3
                left-3
                rounded-xl
                bg-white/95
                px-3
                py-2
                shadow-xl
                backdrop-blur-md
                sm:bottom-5
                sm:left-5
                sm:px-4
                sm:py-3
              "
            >
              <p className="text-[11px] font-semibold text-slate-900 sm:text-sm">
                Trusted by Businesses
              </p>

              <p className="text-[9px] text-slate-500 sm:text-xs">
                Across multiple industries
              </p>
            </motion.div>
          </motion.div>

          {/* Right Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{
              duration: 0.5,
              delay: 0.1,
            }}
            className="order-2 space-y-4 md:order-1 md:space-y-5"
          >

            {/* ================= Mission ================= */}

            <motion.div
              whileHover={{
                y: -6,
                scale: 1.01,
              }}
              whileTap={{
                scale: 0.98,
              }}
              transition={{ duration: 0.3 }}
              className="
                group
                relative
                overflow-hidden
                rounded-2xl
                md:rounded-3xl
                border
                border-slate-200
                bg-gradient-to-br
                from-white
                to-slate-50
                p-4
                sm:p-5
                shadow-[0_8px_20px_rgba(15,23,42,.06),0_20px_50px_rgba(15,23,42,.08)]
                transition-all
                duration-500
                hover:border-pink-500
                hover:shadow-[0_12px_30px_rgba(15,23,42,.10),0_30px_80px_rgba(236,72,153,.18)]
              "
            >
              {/* Animated Glow */}

              <motion.div
                animate={{
                  x: [-80, 250, -80],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "linear",
                }}
                className="
                  absolute
                  top-0
                  h-full
                  w-16
                  sm:w-20
                  md:w-24
                  rotate-12
                  bg-white/30
                  blur-lg
                  md:blur-xl
                "
              />

              {/* Accent */}

              <div className="absolute left-0 top-0 h-full w-[3px] md:w-1 bg-gradient-to-b from-pink-500 to-fuchsia-600" />

              <h4 className="text-lg font-bold text-slate-900 sm:text-xl">
                Our Mission
              </h4>

              <p className="mt-2 text-sm leading-6 text-slate-600 sm:text-base md:leading-7">
                Our mission is to empower businesses with innovative digital
                and enterprise technology solutions that improve efficiency,
                accelerate growth, and create sustainable value through
                innovation, reliability, and customer-centric service.
              </p>

            </motion.div>
                        {/* ================= Vision ================= */}

                        <motion.div
              whileHover={{
                y: -6,
                scale: 1.01,
              }}
              whileTap={{
                scale: 0.98,
              }}
              transition={{ duration: 0.3 }}
              className="
                group
                relative
                overflow-hidden
                rounded-2xl
                md:rounded-3xl
                border
                border-slate-200
                bg-gradient-to-br
                from-white
                to-slate-50
                p-4
                sm:p-5
                shadow-[0_8px_20px_rgba(15,23,42,.06),0_20px_50px_rgba(15,23,42,.08)]
                transition-all
                duration-500
                hover:border-indigo-500
                hover:shadow-[0_12px_30px_rgba(15,23,42,.10),0_30px_80px_rgba(99,102,241,.18)]
              "
            >
              {/* Animated Glow */}

              <motion.div
                animate={{
                  x: [-80, 250, -80],
                }}
                transition={{
                  duration: 6,
                  repeat: Infinity,
                  ease: "linear",
                }}
                className="
                  absolute
                  top-0
                  h-full
                  w-16
                  sm:w-20
                  md:w-24
                  rotate-12
                  bg-white/30
                  blur-lg
                  md:blur-xl
                "
              />

              {/* Left Accent */}

              <div className="absolute left-0 top-0 h-full w-[3px] md:w-1 bg-gradient-to-b from-indigo-500 to-sky-500" />

              <h4 className="text-lg sm:text-xl font-bold text-slate-900">
                Our Vision
              </h4>

              <p className="mt-2 text-sm sm:text-base leading-6 md:leading-7 text-slate-600">
                To be a trusted global technology partner, empowering
                businesses with innovative digital and enterprise solutions
                that inspire growth, drive transformation, and create a
                smarter, more connected future.
              </p>

            </motion.div>

          </motion.div>

        </div>

      </div>
    </section>
  );
}

export default About;